import { FormValues } from '../../duck';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { Select } from '@lon/mathnation-suit/components';
import { stateList } from '@lon/shared/utils';

const SelectState: React.FC = () => {
  const { watch, setValue } = useFormContext<FormValues>();
  const { state: stateValue } = useLocation();
  const [state] = watch(['state']);
  const [stateInputValue, setStateInputValue] = React.useState('');

  React.useEffect(() => {
    if (stateValue?.stateValue) {
      const initialValue = stateValue.stateValue.toLocaleUpperCase();
      setStateInputValue(initialValue);
      setValue('state', initialValue);
    } else {
      setStateInputValue(state || '');
    }
  }, []);

  return (
    <Select
      isRequired
      value={stateInputValue}
      options={stateList()}
      label="State"
      placeholder="Select your state"
      onChange={(value) => {
        setStateInputValue(value as string);
        setValue('state', value as any);
      }}
    />
  );
};

export default SelectState;
